const ShowLabelFontColor = () => localStorage.getItem("fontColor") || "#ffffff";
export default ShowLabelFontColor;
